import moment from 'moment';
import { formatNumber } from '@oms/utils';

export const formatTime = time =>
  moment(time).format('YYYY-MM-DD HH:mm [(CET)]');

const abbrMap = {
  million: {
    en: 'M.',
    no: 'Mill.',
    sv: 'Mkr.',
  },
  billion: {
    en: 'B.',
    no: 'Mrd.',
    sv: 'Mdkr.',
  },
};

export const formatNumberWithAbbr = (number, lang, fractionSize) => {
  if (number >= 1000000000) {
    const abbr = abbrMap.billion[lang];
    return `${formatNumber(number / 1000000000, fractionSize)} ${abbr}`;
  }

  if (number >= 1000000) {
    const abbr = abbrMap.million[lang];
    return `${formatNumber(number / 1000000, fractionSize)} ${abbr}`;
  }

  return formatNumber(number, fractionSize);
};
